// extracted by mini-css-extract-plugin
export default {"marketParamHead":"HeadGroup_marketParamHead--dEW","typeName":"HeadGroup_typeName--KCL"};